import benefits from "../assets/languages/benefits.json";
import translations from "../assets/languages/translations.json";

const environments = {
  /*
   * Dev in the new environments is Lambs Dev environment and will not provide access
   */
  // dev: ["dev.accorplusdev.com"],
  localhost: ["localhost"],
  staging: ["staging.accorplusdev.com"],
  uat: ["uat.accorplusdev.com"],
  prod: [
    "accorplus.com",
    "www.accorplus.com",
    "nprod.accorplus.com",
    "www.accorplusdev.com",
    "accorplusdev.com",
  ],
};

const reverseEnvironments = [...Object.entries(environments)].reduce(
  (pv, [envName, enviromentHostname]) => {
    for (const e of enviromentHostname) {
      pv.set(e, envName);
    }
    return pv;
  },
  new Map(),
);

const environmentConfiguration = {
  localhost: {
    payments_base_url: "https://payments-api-uat.accorplus.com/",
    payments_base_oauth_url: "https://payments-api-uat.accorplus.com/v1/dev",
    payments_api_version: "v1",
    integration_base_url: "https://api-uat.accorplus.com/",
    integration_api_version: "v1",
    payments_login_url: "https://payments-api-uat.accorplus.com/v1/dev",

    checkout_module_url: "https://staging-checkout.accorplusdev.com",

    baseUrl: "",
    urlRoot: `https://staging.accorplusdev.com/`,

    translations: translations,
    benefits: benefits,
  },
  /*
   * As Dev is Lambs development environment, use staging for dev
   * This is also the default configuration if the environment is unknown
   */
  staging: {
    payments_base_url: "https://payments-api-uat.accorplus.com/",
    payments_base_oauth_url: "https://payments-api-uat.accorplus.com/v1",
    payments_api_version: "v1",
    integration_base_url: "https://api-uat.accorplus.com/",
    integration_api_version: "v1",
    payments_login_url: "https://payments-api-uat.accorplus.com/v1",

    checkout_module_url: "https://staging-checkout.accorplusdev.com",

    baseUrl: "https://dev-hotelsales.accorplus.com",
    urlRoot: `https://staging.accorplusdev.com/`,

    translations: translations,
    benefits: benefits,
  },
  /*
   * As Dev is Lambs development environment, use uat as staging
   */
  uat: {
    payments_base_url: "https://payments-api.accorplus.com/",
    payments_base_oauth_url: "https://payments-api.accorplus.com/v1",
    payments_api_version: "v1",
    integration_base_url: "https://int-api.accorplus.com/",
    integration_api_version: "v1",
    payments_login_url: "https://payments-api.accorplus.com/v1",

    checkout_module_url: "https://uat-checkout.accorplusdev.com",

    baseUrl: "https://hotelsales.accorplus.com",
    urlRoot: "https://uat.accorplusdev.com/",

    translations: translations,
    benefits: benefits,
  },
  prod: {
    payments_base_url: "https://payments-api.accorplus.com/",
    payments_base_oauth_url: "https://payments-api.accorplus.com/v1",
    payments_api_version: "v1",
    integration_base_url: "https://int-api.accorplus.com/",
    integration_api_version: "v1",
    payments_login_url: "https://payments-api.accorplus.com/v1",

    checkout_module_url: "https://checkout.accorplus.com",

    baseUrl: "https://hotelsales.accorplus.com",
    urlRoot: "https://www.accorplus.com/",

    translations: translations,
    benefits: benefits,
  },
};

export const getEnvironmentConfiguration = () => {
  const env = reverseEnvironments.get(window.location.hostname) ?? "staging";
  return environmentConfiguration[env];
};

export const isLocalhost = () => {
  return reverseEnvironments.get(window.location.hostname) == "localhost";
};

export const isProdEnvironment = () => {
  return reverseEnvironments.get(window.location.hostname) == "prod";
};
